import moment from "moment";
import { ObjectType } from "typescript";
import WebService from "./WebService";
import { toast } from "react-toastify";
const HelperService = {

  getFormatedDateByDMY(d: any) {
    return d && d !== "0000-00-00" ? moment(d).format("DD-MMM-YYYY") : "NA";
  },
  getFormatedDateForDetail(dt: any, format?: any) {
    var stillUtc = moment.utc(dt).toDate();
    if (dt) {
      if (format) {
        return moment(stillUtc).local().format(format);
      } else {
        return moment(stillUtc).local().format(
          "DD-MM-YYYY  hh:mm A"
        );
      }
    }
  },
  getCurrencyFormatter: function (e:any) {
    if (e === null || e === undefined || e === "") {
      return "0.00";
    }

    const parsedValue = parseFloat(e);

    if (!isNaN(parsedValue)) {
      return new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(parsedValue);
    } else {
      return "0.00";
    }
  },

  allowOnlyNumericValue(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 11) {
      e.preventDefault();
      return false;
    }
  },


  
  isValidEmail(email: string) {
    let strRegex = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
    return email ? strRegex.test(email) : true;
  },
};





export default HelperService;
